import { CalendarCheckIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import type { UpdateAppointmentFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

export function UpdateAppointmentNode({ data, selected }: NodeProps<UpdateAppointmentFlowNode>) {
  return (
    <NodeShell
      icon={CalendarCheckIcon}
      accent="cyan"
      kind="Confirm appointment"
      label={data.label}
      description="Mark confirmed in your practice system"
      selected={selected}
    />
  )
}
